import containsRequiredItemsBaseValidator from './containsRequiredItems';

export default containsRequiredItemsBaseValidator;
